"use client";

import { useEffect, useState } from "react";

export default function ReadingProgressBar({ targetRef }) {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      if (!targetRef?.current) return;

      const element = targetRef.current;

      const rect = element.getBoundingClientRect();
      const windowHeight = window.innerHeight;

      const totalHeight = element.offsetHeight;

      // kitna scroll ho chuka hai content ke andar
      const scrolled = Math.min(
        totalHeight,
        Math.max(0, windowHeight - rect.top),
      );

      const percent = (scrolled / totalHeight) * 100;

      setProgress(percent);
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, [targetRef]);

  return (
    <div className="fixed top-0 left-0 w-full h-[4px] z-50 bg-white">
      <div
        className="h-full bg-black transition-all duration-150"
        style={{ width: `${progress}%` }}
      />
    </div>
  );
}

// import { useEffect, useState } from "react";

// export default function ReadingProgressBar() {
//   const [progress, setProgress] = useState(0);

//   useEffect(() => {
//     const handleScroll = () => {
//       const scrollTop = window.scrollY;
//       const docHeight =
//         document.documentElement.scrollHeight - window.innerHeight;

//       const scrollPercent = (scrollTop / docHeight) * 100;
//       setProgress(scrollPercent);
//     };

//     window.addEventListener("scroll", handleScroll);

//     return () => window.removeEventListener("scroll", handleScroll);
//   }, []);

//   return (
//     <div className="fixed top-0 left-0 w-full h-[4px] z-50 bg-white">
//       <div
//         className="h-full bg-black transition-all duration-150"
//         style={{ width: `${progress}%` }}
//       />
//     </div>
//   );
// }
